// Company news posts that live in the codebase rather than the CMS.
// They are merged with the CMS posts on the Blog page and resolved by slug on the detail page.
const newsPosts = [
  {
    id: "news-comptia-security-plus-sasolburg",
    title: "CompTIA Security+ Training in Sasolburg",
    slug: "comptia-security-plus-training-sasolburg",
    category: ["Cybersecurity", "CompTIA", "Training"],
    content:
      "<p>Ikusasa Technology Solutions is implementing a four-month CompTIA Security+ training programme at Flavius Mareka TVET College in Sasolburg, Free State.</p>" +
      "<p>The programme equips participants with cybersecurity knowledge and practical skills while preparing them for the internationally recognised CompTIA Security+ certification. Through this training, we aim to strengthen access to opportunities in the ICT sector and support the development of future cybersecurity professionals.</p>",
    featuredImage: "/images/CybsersecurityTraining2.jpg",
    gallery: [
      "/images/CybsersecurityTraining1.jpg",
      "/images/CybsersecurityTraining2.jpg",
    ],
    createdAt: "2026-10-13T10:00:00+02:00",
    username: "Ikusasa Technology Solutions",
  },
  {
    id: "news-grade-12-iot-graduates",
    title: "Celebrating Our Grade 12 IoT Graduates",
    slug: "celebrating-our-grade-12-iot-graduates",
    category: ["IoT", "Youth Development"],
    content:
      "<p>We are proud to celebrate our current Grade 12 learners who have graduated from the IoT programme and are now preparing to write their final school examinations.</p>" +
      "<p>Their journey reflects commitment, growth and a willingness to learn. Alongside their academic studies, they have developed digital skills that will support their next steps in education and the world of work.</p>" +
      "<p>We wish them every success in their finals. Keep believing in yourselves—your hard work matters, and we are cheering you on!</p>",
    featuredImage: "/images/grade12-1.jpeg",
    gallery: [
      "/images/grade12-1.jpeg",
      "/images/grade12-2.jpeg",
      "/images/grade12-3.jpeg",
    ],
    createdAt: "2026-10-13T09:00:00+02:00",
    username: "Ikusasa Technology Solutions",
  },
];

export default newsPosts;
